<form [formGroup]="formFiltri">
    <fieldset class="border border-primary border-width-3 rounded-5 p-2">
        <legend class="w-auto fs-5 text-center">
            <h3>Filtri</h3>
        </legend>
        <div class="row">
            <div class="col-2 m-3">
                <h5 class="text-center">Parametri Donchian</h5>
                <div class="row mt-2">
                    <div class="col-12">
                        <mdb-form-control>
                            <mdb-select formControlName="daAnno">
                                @for(item of listaAnni; track item){
                                <mdb-option [value]="item">{{item}}</mdb-option>
                                }
                            </mdb-select>
                            <label mdbLabel class="form-label">Anno inizio test</label>
                        </mdb-form-control>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-12">
                        <mdb-form-control>
                            <mdb-select formControlName="fotsi2">
                                <mdb-option [value]="true">Con filtro CrossTrend</mdb-option>
                                <mdb-option [value]="false">Senza filtro CrossTrend</mdb-option>
                            </mdb-select>
                            <label mdbLabel class="form-label">CrossTrend</label>
                        </mdb-form-control>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-12">
                        <mdb-form-control>
                            <mdb-select formControlName="donchian">
                                <mdb-option [value]="10">10</mdb-option>
                                <mdb-option [value]="20">20</mdb-option>
                                <mdb-option [value]="30">30</mdb-option>
                                <mdb-option [value]="40">40</mdb-option>
                                <mdb-option [value]="50">50</mdb-option>
                                <mdb-option [value]="100">100</mdb-option>
                                <mdb-option [value]="150">150</mdb-option>
                                <mdb-option [value]="200">200</mdb-option>
                            </mdb-select>
                            <label mdbLabel class="form-label">Step Donchian</label>
                        </mdb-form-control>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-12">
                        <mdb-form-control>
                            <mdb-select formControlName="media">
                                <mdb-option [value]="0">Nessuno</mdb-option>
                                <mdb-option [value]="20">20</mdb-option>
                                <mdb-option [value]="50">50</mdb-option>
                                <mdb-option [value]="100">100</mdb-option>
                                <mdb-option [value]="150">150</mdb-option>
                                <mdb-option [value]="200">200</mdb-option>
                            </mdb-select>
                            <label mdbLabel class="form-label">Step Media</label>
                        </mdb-form-control>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-12">
                        <mdb-form-control (valueChange)="calcolaPercentualeSoglia($event)">
                            <mdb-select formControlName="takeprofit">
                                @for(item of listaTP; track item){
                                <mdb-option [value]="item">{{item}}</mdb-option>
                                }
                            </mdb-select>
                            <label mdbLabel class="form-label">Take Profit</label>
                        </mdb-form-control>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-12 text-end">
                        <button type="button" class="btn btn-primary" (click)="filtra()">Applica filtri</button>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-12">
                        <span style="font-weight: bold;">Calcolo perc. pos. soglia Profitto:</span>
                        <br>
                        <span style="color: blue; font-weight: bold;">{{sogliaProfitto}}</span>
                    </div>
                </div>
                <div class="row mt-2">
                    <mdb-form-control>
                        <input class="form-check-input" type="checkbox" id="chkLun"
                            (click)="impostaVolumeVariabile($event)" [(ngModel)]="volumeVariabile"
                            [ngModelOptions]="{standalone: true}" [checked]="false" />
                        <label mdbLabel class="form-label">Imposta Volume variabile</label>
                    </mdb-form-control>
                </div>
            </div>
            <div class="col-5 m-3">
                <div class="row">
                    <div class="col-12">
                        <h5 class="text-center">Giorni della settimana</h5>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">Buy & Sell
                        <form [formGroup]="weekday">
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" id="chkLun"
                                    formControlName="lun" [checked]="true" />
                                <label class="form-check-label" for="chkLun"> Lunedì </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkMar"
                                    formControlName="mar" [checked]="true" />
                                <label class="form-check-label" for="chkMar"> Martedì </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkMer"
                                    formControlName="mer" [checked]="true" />
                                <label class="form-check-label" for="chkMer"> Mercoledì </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkGio"
                                    formControlName="gio" [checked]="true" />
                                <label class="form-check-label" for="chkGio"> Giovedì </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkVen"
                                    formControlName="ven" [checked]="true" />
                                <label class="form-check-label" for="chkVen"> Venerdì </label>
                            </div>
                        </form>
                    </div>
                    <div class="col-4">Buy
                        <form [formGroup]="weekdayBuy">
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" id="chkLun"
                                    formControlName="lun" [checked]="true" />
                                <label class="form-check-label" for="chkLun"> Lunedì </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkMar"
                                    formControlName="mar" [checked]="true" />
                                <label class="form-check-label" for="chkMar"> Martedì </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkMer"
                                    formControlName="mer" [checked]="true" />
                                <label class="form-check-label" for="chkMer"> Mercoledì </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkGio"
                                    formControlName="gio" [checked]="true" />
                                <label class="form-check-label" for="chkGio"> Giovedì </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkVen"
                                    formControlName="ven" [checked]="true" />
                                <label class="form-check-label" for="chkVen"> Venerdì </label>
                            </div>
                        </form>
                    </div>
                    <div class="col-4">Sell
                        <form [formGroup]="weekdaySell">
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" id="chkLun"
                                    formControlName="lun" [checked]="true" />
                                <label class="form-check-label" for="chkLun"> Lunedì </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkMar"
                                    formControlName="mar" [checked]="true" />
                                <label class="form-check-label" for="chkMar"> Martedì </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkMer"
                                    formControlName="mer" [checked]="true" />
                                <label class="form-check-label" for="chkMer"> Mercoledì </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkGio"
                                    formControlName="gio" [checked]="true" />
                                <label class="form-check-label" for="chkGio"> Giovedì </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkVen"
                                    formControlName="ven" [checked]="true" />
                                <label class="form-check-label" for="chkVen"> Venerdì </label>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-12">
                        <h5 class="text-center mt-3">Mesi</h5>
                    </div>
                    <div class="row">
                        <div class="col-4">Buy $ Sell
                            <form [formGroup]="mesi">
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" id="chkGen"
                                        formControlName="gen" [checked]="true" />
                                    <label class="form-check-label" for="chkGen"> Gennaio </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkFeb"
                                        formControlName="feb" [checked]="true" />
                                    <label class="form-check-label" for="chkFeb"> Febbraio </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkMarzo"
                                        formControlName="marzo" [checked]="true" />
                                    <label class="form-check-label" for="chkMarzo"> Marzo </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkApr"
                                        formControlName="apr" [checked]="true" />
                                    <label class="form-check-label" for="chkApr"> Aprile </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkMag"
                                        formControlName="mag" [checked]="true" />
                                    <label class="form-check-label" for="chkMag"> Maggio </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkGiu"
                                        formControlName="giu" [checked]="true" />
                                    <label class="form-check-label" for="chkGiu"> Giugno </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkLug"
                                        formControlName="lug" [checked]="true" />
                                    <label class="form-check-label" for="chkLug"> Luglio </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkAgo"
                                        formControlName="ago" [checked]="true" />
                                    <label class="form-check-label" for="chkAgo"> Agosto </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkSet"
                                        formControlName="set" [checked]="true" />
                                    <label class="form-check-label" for="chkSet"> Settembre </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOtt"
                                        formControlName="ott" [checked]="true" />
                                    <label class="form-check-label" for="chkOtt"> Ottobre </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkNov"
                                        formControlName="nov" [checked]="true" />
                                    <label class="form-check-label" for="chkNov"> Novembre </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkDic"
                                        formControlName="dic" [checked]="true" />
                                    <label class="form-check-label" for="chkDic"> Dicembre </label>
                                </div>
                            </form>
                        </div>
                        <div class="col-4">Buy
                            <form [formGroup]="mesiBuy">
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" id="chkGen"
                                        formControlName="gen" [checked]="true" />
                                    <label class="form-check-label" for="chkGen"> Gennaio </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkFeb"
                                        formControlName="feb" [checked]="true" />
                                    <label class="form-check-label" for="chkFeb"> Febbraio </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkMarzo"
                                        formControlName="marzo" [checked]="true" />
                                    <label class="form-check-label" for="chkMarzo"> Marzo </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkApr"
                                        formControlName="apr" [checked]="true" />
                                    <label class="form-check-label" for="chkApr"> Aprile </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkMag"
                                        formControlName="mag" [checked]="true" />
                                    <label class="form-check-label" for="chkMag"> Maggio </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkGiu"
                                        formControlName="giu" [checked]="true" />
                                    <label class="form-check-label" for="chkGiu"> Giugno </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkLug"
                                        formControlName="lug" [checked]="true" />
                                    <label class="form-check-label" for="chkLug"> Luglio </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkAgo"
                                        formControlName="ago" [checked]="true" />
                                    <label class="form-check-label" for="chkAgo"> Agosto </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkSet"
                                        formControlName="set" [checked]="true" />
                                    <label class="form-check-label" for="chkSet"> Settembre </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOtt"
                                        formControlName="ott" [checked]="true" />
                                    <label class="form-check-label" for="chkOtt"> Ottobre </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkNov"
                                        formControlName="nov" [checked]="true" />
                                    <label class="form-check-label" for="chkNov"> Novembre </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkDic"
                                        formControlName="dic" [checked]="true" />
                                    <label class="form-check-label" for="chkDic"> Dicembre </label>
                                </div>
                            </form>
                        </div>
                        <div class="col-4">Sell
                            <form [formGroup]="mesiSell">
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" id="chkGen"
                                        formControlName="gen" [checked]="true" />
                                    <label class="form-check-label" for="chkGen"> Gennaio </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkFeb"
                                        formControlName="feb" [checked]="true" />
                                    <label class="form-check-label" for="chkFeb"> Febbraio </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkMarzo"
                                        formControlName="marzo" [checked]="true" />
                                    <label class="form-check-label" for="chkMarzo"> Marzo </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkApr"
                                        formControlName="apr" [checked]="true" />
                                    <label class="form-check-label" for="chkApr"> Aprile </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkMag"
                                        formControlName="mag" [checked]="true" />
                                    <label class="form-check-label" for="chkMag"> Maggio </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkGiu"
                                        formControlName="giu" [checked]="true" />
                                    <label class="form-check-label" for="chkGiu"> Giugno </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkLug"
                                        formControlName="lug" [checked]="true" />
                                    <label class="form-check-label" for="chkLug"> Luglio </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkAgo"
                                        formControlName="ago" [checked]="true" />
                                    <label class="form-check-label" for="chkAgo"> Agosto </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkSet"
                                        formControlName="set" [checked]="true" />
                                    <label class="form-check-label" for="chkSet"> Settembre </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOtt"
                                        formControlName="ott" [checked]="true" />
                                    <label class="form-check-label" for="chkOtt"> Ottobre </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkNov"
                                        formControlName="nov" [checked]="true" />
                                    <label class="form-check-label" for="chkNov"> Novembre </label>
                                </div>
                                <div class="form-check">
                                    <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkDic"
                                        formControlName="dic" [checked]="true" />
                                    <label class="form-check-label" for="chkDic"> Dicembre </label>
                                </div>
                            </form>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-4">
                <div class="row">
                    <div class="col-12">
                        <h5 class="text-center">Ore di trading</h5>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        Buy & Sell
                        <form [formGroup]="orari">
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" id="chkOra0"
                                    formControlName="ora0" [checked]="true" />
                                <label class="form-check-label" for="chkOra0"> 0 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" id="chkOra1"
                                    formControlName="ora1" [checked]="true" />
                                <label class="form-check-label" for="chkOra1"> 1 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra2"
                                    formControlName="ora2" [checked]="true" />
                                <label class="form-check-label" for="chkOra2"> 2 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra3"
                                    formControlName="ora3" [checked]="true" />
                                <label class="form-check-label" for="chkOra3"> 3 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra4"
                                    formControlName="ora4" [checked]="true" />
                                <label class="form-check-label" for="chkOra4"> 4 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra5"
                                    formControlName="ora5" [checked]="true" />
                                <label class="form-check-label" for="chkOra5"> 5 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra6"
                                    formControlName="ora6" [checked]="true" />
                                <label class="form-check-label" for="chkOra6"> 6 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra7"
                                    formControlName="ora7" [checked]="true" />
                                <label class="form-check-label" for="chkOra7"> 7 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra8"
                                    formControlName="ora8" [checked]="true" />
                                <label class="form-check-label" for="chkOra8"> 8 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra9"
                                    formControlName="ora9" [checked]="true" />
                                <label class="form-check-label" for="chkOra9"> 9 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra10"
                                    formControlName="ora10" [checked]="true" />
                                <label class="form-check-label" for="chkOra10"> 10 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra11"
                                    formControlName="ora11" [checked]="true" />
                                <label class="form-check-label" for="chkOra11"> 11 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra12"
                                    formControlName="ora12" [checked]="true" />
                                <label class="form-check-label" for="chkOra12"> 12 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra13"
                                    formControlName="ora13" [checked]="true" />
                                <label class="form-check-label" for="chkOra13"> 13 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra14"
                                    formControlName="ora14" [checked]="true" />
                                <label class="form-check-label" for="chkOra14"> 14 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra15"
                                    formControlName="ora15" [checked]="true" />
                                <label class="form-check-label" for="chkOra15"> 15 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra16"
                                    formControlName="ora16" [checked]="true" />
                                <label class="form-check-label" for="chkOra16"> 16 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra17"
                                    formControlName="ora17" [checked]="true" />
                                <label class="form-check-label" for="chkOra17"> 17 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra18"
                                    formControlName="ora18" [checked]="true" />
                                <label class="form-check-label" for="chkOra18"> 18 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra19"
                                    formControlName="ora19" [checked]="true" />
                                <label class="form-check-label" for="chkOra19"> 19 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra20"
                                    formControlName="ora20" [checked]="true" />
                                <label class="form-check-label" for="chkOra20"> 20 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra21"
                                    formControlName="ora21" [checked]="true" />
                                <label class="form-check-label" for="chkOra21"> 21 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra22"
                                    formControlName="ora22" [checked]="true" />
                                <label class="form-check-label" for="chkOra22"> 22 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra23"
                                    formControlName="ora23" [checked]="true" />
                                <label class="form-check-label" for="chkOra23"> 23 </label>
                            </div>
                        </form>
                    </div>
                    <div class="col-4">
                        Buy
                        <form [formGroup]="orariBuy">
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" id="chkOra0"
                                    formControlName="ora0" [checked]="true" />
                                <label class="form-check-label" for="chkOra0"> 0 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" id="chkOra1"
                                    formControlName="ora1" [checked]="true" />
                                <label class="form-check-label" for="chkOra1"> 1 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra2"
                                    formControlName="ora2" [checked]="true" />
                                <label class="form-check-label" for="chkOra2"> 2 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra3"
                                    formControlName="ora3" [checked]="true" />
                                <label class="form-check-label" for="chkOra3"> 3 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra4"
                                    formControlName="ora4" [checked]="true" />
                                <label class="form-check-label" for="chkOra4"> 4 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra5"
                                    formControlName="ora5" [checked]="true" />
                                <label class="form-check-label" for="chkOra5"> 5 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra6"
                                    formControlName="ora6" [checked]="true" />
                                <label class="form-check-label" for="chkOra6"> 6 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra7"
                                    formControlName="ora7" [checked]="true" />
                                <label class="form-check-label" for="chkOra7"> 7 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra8"
                                    formControlName="ora8" [checked]="true" />
                                <label class="form-check-label" for="chkOra8"> 8 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra9"
                                    formControlName="ora9" [checked]="true" />
                                <label class="form-check-label" for="chkOra9"> 9 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra10"
                                    formControlName="ora10" [checked]="true" />
                                <label class="form-check-label" for="chkOra10"> 10 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra11"
                                    formControlName="ora11" [checked]="true" />
                                <label class="form-check-label" for="chkOra11"> 11 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra12"
                                    formControlName="ora12" [checked]="true" />
                                <label class="form-check-label" for="chkOra12"> 12 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra13"
                                    formControlName="ora13" [checked]="true" />
                                <label class="form-check-label" for="chkOra13"> 13 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra14"
                                    formControlName="ora14" [checked]="true" />
                                <label class="form-check-label" for="chkOra14"> 14 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra15"
                                    formControlName="ora15" [checked]="true" />
                                <label class="form-check-label" for="chkOra15"> 15 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra16"
                                    formControlName="ora16" [checked]="true" />
                                <label class="form-check-label" for="chkOra16"> 16 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra17"
                                    formControlName="ora17" [checked]="true" />
                                <label class="form-check-label" for="chkOra17"> 17 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra18"
                                    formControlName="ora18" [checked]="true" />
                                <label class="form-check-label" for="chkOra18"> 18 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra19"
                                    formControlName="ora19" [checked]="true" />
                                <label class="form-check-label" for="chkOra19"> 19 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra20"
                                    formControlName="ora20" [checked]="true" />
                                <label class="form-check-label" for="chkOra20"> 20 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra21"
                                    formControlName="ora21" [checked]="true" />
                                <label class="form-check-label" for="chkOra21"> 21 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra22"
                                    formControlName="ora22" [checked]="true" />
                                <label class="form-check-label" for="chkOra22"> 22 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra23"
                                    formControlName="ora23" [checked]="true" />
                                <label class="form-check-label" for="chkOra23"> 23 </label>
                            </div>
                        </form>
                    </div>
                    <div class="col-4">
                        Sell
                        <form [formGroup]="orariSell">
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" id="chkOra0"
                                    formControlName="ora0" [checked]="true" />
                                <label class="form-check-label" for="chkOra0"> 0 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" id="chkOra1"
                                    formControlName="ora1" [checked]="true" />
                                <label class="form-check-label" for="chkOra1"> 1 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra2"
                                    formControlName="ora2" [checked]="true" />
                                <label class="form-check-label" for="chkOra2"> 2 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra3"
                                    formControlName="ora3" [checked]="true" />
                                <label class="form-check-label" for="chkOra3"> 3 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra4"
                                    formControlName="ora4" [checked]="true" />
                                <label class="form-check-label" for="chkOra4"> 4 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra5"
                                    formControlName="ora5" [checked]="true" />
                                <label class="form-check-label" for="chkOra5"> 5 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra6"
                                    formControlName="ora6" [checked]="true" />
                                <label class="form-check-label" for="chkOra6"> 6 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra7"
                                    formControlName="ora7" [checked]="true" />
                                <label class="form-check-label" for="chkOra7"> 7 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra8"
                                    formControlName="ora8" [checked]="true" />
                                <label class="form-check-label" for="chkOra8"> 8 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra9"
                                    formControlName="ora9" [checked]="true" />
                                <label class="form-check-label" for="chkOra9"> 9 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra10"
                                    formControlName="ora10" [checked]="true" />
                                <label class="form-check-label" for="chkOra10"> 10 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra11"
                                    formControlName="ora11" [checked]="true" />
                                <label class="form-check-label" for="chkOra11"> 11 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra12"
                                    formControlName="ora12" [checked]="true" />
                                <label class="form-check-label" for="chkOra12"> 12 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra13"
                                    formControlName="ora13" [checked]="true" />
                                <label class="form-check-label" for="chkOra13"> 13 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra14"
                                    formControlName="ora14" [checked]="true" />
                                <label class="form-check-label" for="chkOra14"> 14 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra15"
                                    formControlName="ora15" [checked]="true" />
                                <label class="form-check-label" for="chkOra15"> 15 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra16"
                                    formControlName="ora16" [checked]="true" />
                                <label class="form-check-label" for="chkOra16"> 16 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra17"
                                    formControlName="ora17" [checked]="true" />
                                <label class="form-check-label" for="chkOra17"> 17 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra18"
                                    formControlName="ora18" [checked]="true" />
                                <label class="form-check-label" for="chkOra18"> 18 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra19"
                                    formControlName="ora19" [checked]="true" />
                                <label class="form-check-label" for="chkOra19"> 19 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra20"
                                    formControlName="ora20" [checked]="true" />
                                <label class="form-check-label" for="chkOra20"> 20 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra21"
                                    formControlName="ora21" [checked]="true" />
                                <label class="form-check-label" for="chkOra21"> 21 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra22"
                                    formControlName="ora22" [checked]="true" />
                                <label class="form-check-label" for="chkOra22"> 22 </label>
                            </div>
                            <div class="form-check">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="chkOra23"
                                    formControlName="ora23" [checked]="true" />
                                <label class="form-check-label" for="chkOra23"> 23 </label>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-12 text-end">
                <button type="button" class="btn btn-primary me-4" (click)="annullaFiltri()">annulla filtri</button>
                <button type="button" class="btn btn-primary" (click)="resetFiltri()">reset filtri</button>
            </div>
        </div>
    </fieldset>
</form>